var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M106.608 58.906c5.973 0 11.687 2.852 15.265 7.632l15.742 20.99h78.709c10.523 0 19.081 8.567 19.081 19.08v95.405c0 10.523-8.558 19.081-19.081 19.081H63.676c-10.523 0-19.081-8.558-19.081-19.08V77.986c0-10.514 8.558-19.081 19.081-19.081zm0 19.08H63.676v124.027h152.658l-.01-95.405h-78.71c-5.971 0-11.686-2.852-15.264-7.632zm42.937 37.59v28.622h28.622v19.08h-28.622V191.9h-19.08V163.28h-28.622v-19.081h28.621v-28.622z"
})));
export default SvgFolderPlus;